<div class="img-card__content">
	<ng-content />
</div>

@if (imgSrc) {
	<div class="img-card__img" [ngStyle]="{ 'background-image': 'url(' + imgSrc + ')' }"></div>
}
@if (canClose) {
	<fa-icon
		class="img-card__close"
		icon="fa-xmark"
		[alt]="i18nKeys.Actions.Clear | translate"
		(click)="closeClicked.emit(id)"
	/>
}
